/**
 * Inline editor mode configuration.
 * Used for smaller rich-text fields embedded within forms or detail pages.
 */
export const inlineMode = {
  id: "inline",

  layout: {
    showHeader: false,
    showTocSidebar: false,
    showMobileToolbar: true,
    showFloatingToolbar: true,
    showTableHandles: true,
    wrapperClassName: "tiptap-inline-editor-wrapper",
    contentClassName: "tiptap-inline-editor-content",
    layoutClassName: "tiptap-inline-editor-layout",
  },

  editor: {
    editorClassName: "tiptap-inline-editor",
    placeholder: "Start writing...",
  },

  toolbar: {
    showUndoRedo: true,
    showThemeToggle: false,
    showSourceMode: false,
    showFindReplace: false,
    showMarkdownImport: false,
    showMarkdownExport: false,
  },
}

export default inlineMode
